import { Formik, Form, Field, ErrorMessage } from "formik";
import axios from "axios";
import HeroDoc from "../assets/HeroDoc.png";
import checkMark from "../assets/success-green-check-mark.svg";
import redMark from "../assets/red-cross.png";
import { useState } from "react";
import config from "../config";
import ClevertapReact from 'clevertap-react';

export default function GetInTouch() {
    const [successDialog, setSuccessDialog] = useState(false);
    const [isSuccess, setisSuccess] = useState(false);

    function ConfirmationDialog() {
        if (isSuccess) {
            return (
                <div>
                    <div className="px-2 lg:px-10">
                        <div className="flex justify-center space-x-5 mt-20">
                            <img className="w-10" src={checkMark} />
                            <p className="font-black text-2xl">
                                Hold On & Sit Tight
                            </p>
                        </div>
                        <p className="text-lg mt-20 w-full text-center">
                            We've recieved your requirements and someone from
                            our team will reach out to collect further details
                            and answer any questions thay you may have.
                        </p>
                        <div className="w-full flex justify-center mt-10">
                            <button
                                onClick={() => setSuccessDialog(false)}
                                className="btn-primary px-10 mx-auto mb-20"
                            >
                                <span className="arrow left mr-4"></span>Go Back{" "}
                            </button>
                        </div>
                    </div>
                </div>
            );
        } else {
            return (
                <div>
                    <div className="px-2 lg:px-10">
                        <div className="flex justify-center space-x-5 mt-20  w-full">
                            <img className="w-10" src={redMark} />
                            <p className="font-black text-2xl">
                                Something went wrong!
                            </p>
                        </div>
                        <p className="text-lg mt-20 w-full text-center">
                            We are facing some technical difficulties, please
                            check back later. You can also connect with us at{" "}
                            <a href="mailto:Wellnesscare@medibuddy.in">
                                Wellnesscare@medibuddy.in
                            </a>
                        </p>
                        <div className="w-full flex justify-center mt-10">
                            <button
                                onClick={() => setSuccessDialog(false)}
                                className="btn-primary px-10 mx-auto mb-20"
                            >
                                <span className="arrow left mr-4"></span>Go Back{" "}
                            </button>
                        </div>
                    </div>
                </div>
            );
        }
    }

    function FormikForm() {
        return (
            <div>
                <p className="font-black text-2xl pt-6 ml-10">
                    Get a free trial for our tele consultation now.
                </p>
                <p className="font-black ml-10">Limited Offer!</p>
                <Formik
                    initialValues={{
                        getInTouchName: "",
                        getInTouchEmail: "",
                        getInTouchMobile: "",
                        getInTouchDesignation: "",
                        getInTouchEmpCount: "",
                    }}
                    validate={(values) => {
                        return validateForm(values);
                    }}
                    onSubmit={(values, { setSubmitting }) => {
                        submitForm(values);
                    }}
                >
                    <Form action="">
                        <div className="mx-10 mb-6">
                            <div className="flex justify-between flex-wrap">
                                <div className="flex w-full lg:w-5/12 flex-col space-y-1">
                                    <label className="relative top-4 left-3 bg-white fit-content" for="getInTouchName">
                                        Your Name
                                    </label>
                                    <Field
                                        className="border-2 border-grey-400 h-12 px-4 rounded-xl"
                                        id="getInTouchName"
                                        name="getInTouchName"
                                        type="text"
                                    />
                                    <ErrorMessage
                                        className="text-red-600 ml-2"
                                        name="getInTouchName"
                                        component="div"
                                    />
                                </div>
                                <div className="flex w-full lg:w-5/12 flex-col space-y-1">
                                    <label className="relative top-4 left-3 bg-white fit-content"  for="getInTouchEmail">
                                        Work E-mail ID
                                    </label>
                                    <Field
                                        className="border-2 border-grey-400 h-12 px-4 rounded-xl"
                                        id="getInTouchEmail"
                                        name="getInTouchEmail"
                                        type="email"
                                    />
                                    <ErrorMessage
                                        className="text-red-600 ml-2"
                                        name="getInTouchEmail"
                                        component="div"
                                    />
                                </div>
                                <div className="flex w-full lg:w-5/12 flex-col space-y-1">
                                    <label className="relative top-4 left-3 bg-white fit-content"  for="getInTouchMobile">
                                        Mobile Number
                                    </label>
                                    <Field
                                        className="border-2 border-grey-400 h-12 px-4 rounded-xl"
                                        id="getInTouchMobile"
                                        name="getInTouchMobile"
                                        type="number"
                                    />
                                    <ErrorMessage
                                        className="text-red-600 ml-2"
                                        name="getInTouchMobile"
                                        component="div"
                                    />
                                </div>
                                <div className="flex w-full lg:w-5/12 flex-col space-y-1">
                                    <label className="relative top-4 left-3 bg-white fit-content"  for="getInTouchDesignation">
                                        Designation
                                    </label>
                                    <Field
                                        className="border-2 border-grey-400 h-12 px-4 rounded-xl"
                                        id="getInTouchDesignation"
                                        name="getInTouchDesignation"
                                        type="text"
                                    />
                                    <ErrorMessage
                                        className="text-red-600 ml-2"
                                        name="getInTouchDesignation"
                                        component="div"
                                    />
                                </div>
                                <div className="flex w-full lg:w-5/12 flex-col space-y-1">
                                    <label className="relative top-4 left-3 bg-white fit-content"  for="getInTouchEmpCount">
                                        Employees Count
                                    </label>
                                    <Field
                                        className="border-2 border-grey-400 h-12 px-4 rounded-xl"
                                        id="getInTouchEmpCount"
                                        name="getInTouchEmpCount"
                                        type="number"
                                    />
                                    <ErrorMessage
                                        className="text-red-600 ml-2"
                                        name="getInTouchEmpCount"
                                        component="div"
                                    />
                                </div>
                                <div className="w-full lg:w-5/12 relative -top-3">
                                    <button
                                        className="btn-primary mt-10 w-full"
                                        type="submit"
                                    >
                                        Get in Touch{" "}
                                        <span className="arrow right ml-4"></span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </Form>
                </Formik>
            </div>
        );
    }

    async function submitForm(values) {
        try {
            const formPayload = {
                Name: values.getInTouchName,
                Email: values.getInTouchEmail,
                MobileNumber: values.getInTouchMobile,
                EmployeeCount: values.getInTouchEmpCount,
                Role: values.getInTouchDesignation,
                CompanyName: values.getInTouchCompanyName
                    ? values.getInTouchCompanyName
                    : "",
                CompanyWebsiteUrl: values.getInTouchCompanyWebsiteUrl
                    ? values.getInTouchCompanyWebsiteUrl
                    : "",
                from: 1,
            };
            const response = await axios.post(
                config.apiUrl + "smeCorporate/leadGeneration",
                formPayload
            );
            if (response.data.isSuccess) {
                setisSuccess(true);
                ClevertapReact.event("GetInTouch Success", formPayload)
            } else {
                setisSuccess(false);
                ClevertapReact.event("GetInTouch Failure", formPayload)
            }
            setSuccessDialog(true);
        } catch (error) {
            console.log(error);
            ClevertapReact.event("GetInTouch Failure", error.message)
            setSuccessDialog(true);
            setisSuccess(false);
        }
    }

    function validateForm(values) {
        const errors = {};
        if (!values.getInTouchName || values.getInTouchName.trim().length == 0) {
            errors.getInTouchName = "Required";
        }
        if (!values.getInTouchEmail || values.getInTouchEmail.trim().length == 0) {
            errors.getInTouchEmail = "Required";
        }
        if (!values.getInTouchMobile) {
            errors.getInTouchMobile = "Required";
        }
        if (!values.getInTouchDesignation || values.getInTouchDesignation.trim().length == 0) {
            errors.getInTouchDesignation = "Required";
        }
        if (!values.getInTouchEmpCount) {
            errors.getInTouchEmpCount = "Required";
        }
        if (
            values.getInTouchMobile &&
            values.getInTouchMobile.toString().length !== 10
        ) {
            errors.getInTouchMobile = "Mobile Number should be 10 digits";
        }
        return errors;
    }

    return (
        <div className="flex flex-col justify-center items-center">
            <img src={HeroDoc} className="w-56" />
            <div className="bg-white shadow-lg mr-0 rounded-xl">
                {successDialog ? <ConfirmationDialog /> : <FormikForm />}
            </div>
        </div>
    );
}
